import script from "./Account.vue?vue&type=script&setup=true&lang=ts"
export * from "./Account.vue?vue&type=script&setup=true&lang=ts"

import "./Account.vue?vue&type=style&index=0&id=7ea36e6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ea36e6b"]])

export default __exports__